const languageToggleAdapter = data =>
	data?.edges.map(({ node }) => ({
		id: node.context.id,
		path: node.path,
		lang: node.context.locale.toLowerCase().substring(0, 2),
	}));

export { languageToggleAdapter };
